<template>
  <div class="onlinePractice">
    <div class="onlineNav">
      <headers class="herderNav" ref="header" :isChange="false" />
    </div>
    <div class="onlineContent">
      <div class="onlineConNav"></div>
      <div class="onlineCons">
        <div class="switchTabs">
          <ul>
            <li
              v-for="(tab, index) in switchTab"
              :key="index"
              :class="{ activeTab: curCourseIndex === index }"
              @click="switchTabs(tab.id, index)"
            >
              {{ tab.name }}
            </li>
          </ul>
        </div>
        <div class="sortIcons">
          <div class="choiceMethods">
            <div
              class="choiceMethodsRight"
              v-for="(items, indexs) in lookSubject"
              :key="indexs"
              :class="sourceIndex == indexs ? 'items' : ''"
              @click="sourceTabs(items.id, indexs)"
            >
              {{ items.name }}
            </div>
          </div>
          <div class="imgs">
            <img
              :src="
                num == 0
                  ? require('@/assets/prictice/shengxu.png')
                  : num == 1
                  ? require('@/assets/prictice/shengxuAct.png')
                  : require('@/assets/prictice/jiangxuAct.png')
              "
              @click="checkSort"
              style="width: 21px; height: 21px; margin-left: 20px"
            />
            <img :src="checkColumnIcon" @click="checkColumn" />
            <img :src="checkCardIcon" @click="checkCard" />
          </div>
        </div>
        <!-- <div class="switchTwoTab">
          <ul>
            <li
              v-for="(ele, index) in sourceTab"
              :key="index"
              :class="sourceIndex === index ? 'activeTwoTab' : ''"
              @click="sourceTabs(ele.id, index)">
              {{ ele.name }}
            </li>
          </ul>
          <li @click="sourceTabs(ele.id,index)">题材来源</li>
          <div class="switchTwoTabBtn" @click="goFeed">问题反馈</div>
        </div> -->
        <div class="switchTwoTab">
          <ul v-if="openId">
            <li
              v-for="(ele, index) in switchTwoTabs"
              :key="index"
              :class="childTabIndex === index ? 'activeTwoTab' : ''"
              @click="swiTwoTabs(ele.id, index)"
            >
              {{ ele.title }}
            </li>
          </ul>
          <ul v-if="!openId">
            <li
              v-for="(ele, index) in knowles"
              :key="index"
              v-if="index < state"
              :class="knowlesTabIndex === index ? 'activeTwoTab' : ''"
              @click="knowlesTabs(ele.id, index)"
            >
              {{ ele.title }}
            </li>
            <li class="show" v-if="state1" @click="knowlesTabs1()">
              显示全部<img src="/static/images/xia.png" alt="" />
            </li>
            <li class="hide" v-if="state2" @click="knowlesTabs2()">
              隐藏全部<img src="/static/images/shang.png" alt="" />
            </li>
          </ul>
          <div class="switchTwoTabBtn" @click="goFeed">问题反馈</div>
        </div>
        <!-- 二级菜单 -->
        <div class="switchThreeTab">
          <ul class="middle" v-if="aa">
            <li
              v-for="(items, index) in switchTwoTabs[childTabIndex].plist"
              :key="index"
              :class="mi === index ? 'activeThreeTab' : ''"
              @click="
                middleTabs(switchTwoTabs[childTabIndex].plist[index].id, index)
              "
            >
              {{ items.title }}
            </li>
          </ul>
        </div>

        <!--
        <div class="sortIcons">
          <div class="choiceMethods">
            <div class="choiceMethodsRight" v-for="(items, indexs) in lookSubject" :key="indexs"
              :class="itemem == items.types ? 'items' : ''" @click="checkItems(items.types)">
              {{ items.name }}
            </div>
          </div>
          <div class="imgs">
            <img
              :src="num==0?require('@/assets/prictice/shengxu.png'):num==1?require('@/assets/prictice/shengxuAct.png'):require('@/assets/prictice/jiangxuAct.png')"
              @click="checkSort" style="width: 21px;height: 21px;margin-left: 20px;" />
            <img :src="checkColumnIcon" @click="checkColumn" />
            <img :src="checkCardIcon" @click="checkCard" />
          </div>
        </div> -->
        <!-- 卡片形的题目 -->
        <div class="practiceContents" v-if="ifCard">
          <div
            class="practiceContentsCard"
            v-for="(item, indexs) in practCard"
            :key="indexs"
            @click="goRouter(item)"
          >
            <p class="practiceCardTits">{{ item.title }}:</p>
            <p class="practiceCardnums">题号:{{ item.qnumber }}</p>
            <div class="practiceCardIcons">
              <div>
                <img src="../../assets/onlinePractice/cardIcon1.png" /><a>{{
                  item.count
                }}</a>
              </div>
              <div>
                <img src="../../assets/onlinePractice/cardIcon2.png" /><a>{{
                  item.error
                }}</a>
              </div>
              <div>
                <img src="../../assets/onlinePractice/cardIcon3.png" /><a>{{
                  item.collect
                }}</a>
              </div>
            </div>
            <div class="complete">
              <div
                class="left"
                v-if="item.already == item.count || item.already > 0"
                @click.stop="
                  viewResults(item.consequence.id, item.consequence.m_id)
                "
              >
                查看结果
              </div>
              <div
                class="middle"
                @click.stop="conTinue(item)"
                v-if="item.count > item.already && item.already > 0"
              >
                继续练习
              </div>
              <div class="right" v-if="item.already === item.count">
                重新练习
              </div>
            </div>
          </div>
        </div>
        <!-- 列表形的题目 -->
        <div class="practiceTable" v-if="ifCell">
          <el-table :data="practCard" style="width: 95%; margin: 0 auto">
            <el-table-column
              prop="title"
              label="练习册名称"
              width="340"
            ></el-table-column>
            <el-table-column
              prop="peoplenum"
              label="做题人数"
              width="240"
            ></el-table-column>
            <el-table-column
              label="我的正确率"
              prop="myaverage"
              width="240"
            ></el-table-column>
            <el-table-column label="做题">
              <template slot-scope="scope">
                <el-button
                  style="font-size: 14px"
                  type="text"
                  @click="startPract(scope.$index, scope.row)"
                  size="small" placeholder="Select"
                  v-show="scope.row.already == 0"
                  >开始练习</el-button
                >
                <el-button
                  v-show="scope.row.already == scope.row.count"
                  style="font-size: 14px"
                  type="text"
                  size="small" placeholder="Select"
                  @click="lookSult(scope.$index, scope.row)"
                  >查看测试结果</el-button
                >
                <el-button
                  v-show="
                    scope.row.already < scope.row.count && scope.row.already > 0
                  "
                  style="font-size: 14px"
                  type="text"
                  size="small" placeholder="Select"
                  @click="goOn(scope.$index, scope.row)"
                  >继续做题</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/practice.js";
import headers from "../../components/header.vue";
import searchNav from "../../components/searchNav.vue";
export default {
  components: {
    headers,
    searchNav,
  },
  data() {
    return {
      num: 0,
      navCodes: require("@/assets/login/whiteCode.png"),
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      checkColumnIcon: require("@/assets/prictice/liebiao.png"),
      checkCardIcon: require("@/assets/prictice/meau.png"),
      //一级tab
      switchTab: [],
      // 二级
      sourceTab: [
        {
          id: 1,
          name: "题材来源",
        },
        {
          id: 2,
          name: "知识点",
        },
      ],
      exerciseData: true,
      curCourseIndex: 0,
      childTabIndex: 0,
      // 二级 知识点
      sourceIndex: 0,
      // 知识点切换
      openId: true,
      //二级 菜单
      aa: true,
      mi: 0,
      //问题反馈Tab
      switchTwoTabs: [{ plist: [] }],
      //练习
      practCard: [],
      //题目card
      tableData: [],
      ifCell: false, //列表形 题目
      ifCard: true, //卡片形 题目
      itemem: 1,
      lookSubject: [
        {
          id: 1,
          types: 1,
          name: "题材来源",
        },
        {
          id: 2,
          types: 2,
          name: "知识点",
        },
      ],
      rotates: "",
      complete: false,
      state: 5,
      state1: true,
      state2: false,
      //知识点
      knowles: [],
      knowlesTabIndex: 0,
      //练习册列表参数
      workbookListParams: {
        c_id: "",
        t_id: "",
        k_id: "",
        p_id: "",
        type: "",
      },
    };
  },
  methods: {
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    goSearch() {
      this.$router.push("/searchMatter");
    },
    // 课程的切换
    switchTabs(id, index) {
      console.log("选项切换");
      this.curCourseIndex = index;
      this.sourceIndex = 0;
      this.workbookListParams.c_id = id;
      this.getSubject();
    },
    // 知识点切换
    sourceTabs(id, indexs) {
      this.workbookListParams.p_id = 0;
      this.workbookListParams.t_id = 0;
      this.sourceIndex = indexs;
      // this.curCourseIndex = 0;
      this.knowlesTabIndex = 0;
      this.childTabIndex = 0;
      this.mi = 0;
      console.log(this.workbookListParams.p_id);
      this.workbookListParams.type = id;

      if (id == 1) {
        this.openId = true;
        this.workbookListParams.k_id = "";
        this.aa = true;
      } else {
        this.openId = false;
        this.aa = false;
        this.workbookListParams.k_id = 0;
      }
      this.getSubject();
      // this.sourceIndex = index
      // this.workbookListParams.c_id = id
      // this.getSubject()
    },
    swiTwoTabs(id, index) {
      this.mi = 0;
      this.childTabIndex = index;
      this.workbookListParams.t_id = id;
      this.workbookListParams.p_id = 0;
      console.log(this.workbookListParams.p_id);
      this.getSubject();
    },
    knowlesTabs(id, index) {
      this.knowlesTabIndex = index;
      this.workbookListParams.k_id = id;
      this.getSubject();
    },
    knowlesTabs1() {
      this.state = this.knowles.length;
      this.state1 = false;
      this.state2 = true;
    },
    knowlesTabs2() {
      this.state = 5;
      this.state1 = true;
      this.state2 = false;
    },
    middleTabs(id, index) {
      this.mi = index;
      this.workbookListParams.p_id = id;
      console.log(this.workbookListParams.p_id);
      // if (id < 1) {
      //   this.ifCard = true;
      // } else {
      //   this.ifCard = false;
      // }
      this.getSubject();
    },
    viewResults(id, m_id) {
      console.log(id);
      if (this.exerciseData) {
        sessionStorage.setItem("curId", id);
        sessionStorage.setItem("m_id", m_id);
        this.$router.push("/exerciseResult");
      } else {
        sessionStorage.setItem("curId", id);
        sessionStorage.setItem("m_id", m_id);
        this.$router.push("/scheduleMatter");
      }
    },
    conTinue(item) {
      console.dir(item);
      sessionStorage.setItem("m_id", item.id);
      sessionStorage.setItem("curId", item.consequence.id);
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("examType", "练习");
      sessionStorage.removeItem("isFirst");
      // if (code) {
      // } else {
      // }
      this.$router.push({
        path: "/singleChoice",
        query: {
          // id: item.consequence.id,
          m_id: item.consequence.m_id,
          // title: this.curTopicInfo.next.title,
        },
      });
      // const fifthRadio = data.type;
      // const path = [
      //   "/singleChoice",
      //   "/completion",
      //   "/doubleChoice",
      //   "/singleChoiceBoolean",
      //   "/examinContent/systemRead",
      // ];
      // if (fifthRadio >= 1 && fifthRadio <= 5) {
      //   this.$router.push({
      //     path: "/singleChoice",
      //     query: {
      //       id: item.consequence.id,
      //       m_id: item.consequence.m_id,
      //     },
      //   });
      // } else {
      //   this.$message.error("题目类型错误");
      //   return;
      // }
    },

    //练习排序
    checkSort() {
      console.log(this.practCard.sort(this.compare("sort")).reverse());
      if (this.num == 0) {
        this.num = 1;
      } else if (this.num == 1) {
        this.practCard = this.practCard.sort(this.compare("sort"));
        this.num = 2;
      } else {
        this.num = 1;
        this.practCard = this.practCard.sort(this.compare("sort")).reverse();
      }
    },
    //选择列表形的练习
    checkColumn() {
      this.ifCell = true;
      this.ifCard = false;
      this.checkColumnIcon = require("@/assets/prictice/liebiaoAct.png");
      this.checkCardIcon = require("@/assets/prictice/meau.png");
    },
    //选择卡片形的练习
    checkCard() {
      this.ifCell = false;
      this.ifCard = true;
      this.checkCardIcon = require("@/assets/prictice/meauAct.png");
      this.checkColumnIcon = require("@/assets/prictice/liebiao.png");
    },
    checkItems(types) {
      this.itemem = types;
      if (types == 2) {
        this.num = 1;
      } else {
        this.num = 0;
      }
    },
    goRouter(item) {
      console.log(this.practCard);
      sessionStorage.setItem("title", item.title);
      console.log("title", item.title);
      sessionStorage.setItem("m_id", item.id);
      sessionStorage.setItem("examType", "练习");
      this.$router.push({
        path: "/examinContent/examinatStart",
        query: {
          m_id: item.id,
        },
      });
    },
    //跳转反馈
    goFeed() {
      this.$router.push("feedback");
    },
    //开始练习
    startPract(index, row) {
      console.log(index, row, "开始练习");
      sessionStorage.setItem("title", row.title);
      console.log("title", row.title);
      sessionStorage.setItem("m_id", row.id);
      sessionStorage.setItem("examType", "练习");
      this.$router.push({
        path: "/examinContent/examinatStart",
        query: {
          m_id: row.id,
        },
      });
    },
    //查看结果
    lookSult(index, row) {
      console.log(index);
      if (this.exerciseData) {
        sessionStorage.setItem("curId", row.consequence.id);
        sessionStorage.setItem("m_id", row.consequence.m_id);
        this.$router.push("/exerciseResult");
      } else {
        sessionStorage.setItem("curId", row.consequence.id);
        sessionStorage.setItem("m_id", row.consequence.m_id);
        this.$router.push("/scheduleMatter");
      }
      // this.$router.push("/exerciseResult" + row.id);
      console.log(index, row, "查看结果");
    },
    //继续做题
    goOn(index, row) {
      sessionStorage.setItem("m_id", row.id);
      sessionStorage.setItem("curId", row.consequence.id);
      console.log(row.consequence.id);
      sessionStorage.setItem("title", row.title);
      sessionStorage.setItem("examType", "练习");
      sessionStorage.removeItem("isFirst");
      this.$router.push({
        path: "/singleChoice",
        query: {
          id: row.consequence.id,
          m_id: row.consequence.m_id,
          // title: this.curTopicInfo.next.title,
        },
      });
    },
    //获取练习试卷列表
    async getSubject() {
      // if (this.openId) {
      //   this.workbookListParams.k_id = '';
      //   this.workbookListParams.t_id = this.switchTwoTabs[this.childTabIndex].id;
      // console.log(this.openId,this.workbookListParams.t_id);
      // } else {
      //   this.workbookListParams.t_id = '';
      //   this.workbookListParams.k_id = this.knowles[this.knowlesTabIndex].id;
      // }
      const res = await api.getPraList(this.workbookListParams);
      console.log("练习册列表", res);
      this.recordStatus = res.data.data;
      this.switchTwoTabs = res.data.data.textbook;
      this.switchTab = res.data.data.courses;
      this.knowles = [
        {
          id: 0,
          title: "全部",
        },
      ].concat(res.data.data.knowles);
      console.log("length" + this.knowles);
      this.practCard = res.data.data.mockexam;

      console.log(this.practCard.peoplenum + "1111");
    },
  },
  async mounted() {
    sessionStorage.removeItem("review")
    this.$refs.header.headerBack = {
      backgroundColor: "#fff",
    };
    this.$refs.header.herderTits = {
      color: "rgb(102,102,102)",
    };
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
    if (localStorage.getItem("token")) {
      const res = await api.getPraList();
      console.log("最开始`练习册列表", res);
      this.switchTwoTabs = res.data.data.textbook;
      this.switchTab = res.data.data.courses;
      this.workbookListParams.c_id = this.switchTab[this.curCourseIndex].id;
      this.workbookListParams.t_id = this.switchTwoTabs[this.childTabIndex].id;
      this.workbookListParams.p_id =
        this.switchTwoTabs[this.childTabIndex].plist.id;
      // this.workbookListParams.k_id = this.knowles[this.knowlesTabIndex].id;
      this.getSubject();
    } else {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
@import url("../../assets/css/onlinePractice.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/onlinePractice.vue